import * as React from 'react';
import { AuthProvider } from '@sportnet/auth-react';
import { CustomThunkDispatch } from './configureStore';
import { connect } from 'react-redux';
import { setActiveAppspace } from './containers/App/actions';
import { useParams } from 'react-router-dom';
import Administration from './containers/Administration';
import SportnetApi from './sportnetApi';
import api from './api';
import config from './config';

interface OwnProps {
  dispatch: CustomThunkDispatch;
}

type Props = OwnProps;

const Routes: React.FC<Props> = (props) => {
  const { dispatch } = props;
  const { appspace: ppo } = useParams();
  const [loading, setLoading] = React.useState(true);

  return (
    <AuthProvider
      app={config.APP_ID}
      ppo={ppo}
      onAuthorize={({ accessToken }) => {
        if (accessToken) {
          api.setToken(accessToken || '');
          SportnetApi.setToken(accessToken || '');
          dispatch(setActiveAppspace(ppo || ''));
          setLoading(false);
        }
      }}
    >
      {loading ? null : <Administration {...props} />}
    </AuthProvider>
  );
};

export default connect()(Routes);
